export default __webpack_public_path__ + "static/media/team5.93f6b445.png";